// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useCallback } from "react";

import Organize from "../Organize";
import useBoolean from "src/hooks/useBoolean";
import Icon from "src/icons";
import { RelativeBox } from "src/styles/box";
import BlueOutlineButton from "src/components/Buttons/BlueOutline";

const Customize = () => {
  const { value: customize, toggleBoolean } = useBoolean();

  const toggleCustomize = useCallback(
    (event: any) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      toggleBoolean();
    },
    [toggleBoolean],
  );

  const preventDefault = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <>
      <BlueOutlineButton
        leftIcon={<Icon type="editblue" />}
        onClick={toggleCustomize}
      >
        {i18n.t(k.CUSTOMIZE_VIEW)}
      </BlueOutlineButton>
      {customize && (
        <RelativeBox onClick={preventDefault}>
          <Organize handleClose={toggleCustomize} />
        </RelativeBox>
      )}
    </>
  );
};

export default Customize;
